<div class="trial-editor" *ngIf="trial">
  <ng-container>
    <gen-trial-header [trial]="trial" class="trial-viewer-top">
    </gen-trial-header>

    <div  *ngIf="trial.profile">
      <gen-cohort-viewer class="cohort-anchor"
                         *ngFor="let cohort of trial.profile.cohorts"
                         [cohort]="cohort"
                         [curationStatus]="curationStatus"
      >
      </gen-cohort-viewer>
    </div>
  </ng-container>
</div>
